<template>
  <v-layout>
    <v-row align="center" justify="center">
      <v-col cols="10" md="6">
        <h1 class="Hijrnotes" style="font-size: 4em; text-align: center;">The Great Academy</h1>
        <p style="color: white">We are currently moving the platform to a new server and building new services with many new features. Please be patient and until then you can still watch and buy your videos at the link below...</p>
        <v-card-actions>
          <a href="https://videos.thegreat.academy"><v-btn color="primary">WATCH VIDEOS</v-btn></a>
          <v-spacer></v-spacer>
          <router-link to="/presale"><v-btn color="accent">PRE-SALE</v-btn></router-link>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
export default {
  name: 'Home'
}
</script>
